import { useRef, useEffect, useState } from "react";
function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value]);
  return debouncedValue;
}
function useDebouncedCallback(value, delay, callback) {
  const debouncedValue = useDebounce(value, delay);
  const isFirstRun = useRef(true);
  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    callback(debouncedValue);
  }, [debouncedValue]);
}
export {
  useDebounce,
  useDebouncedCallback
};
//# sourceMappingURL=debounce.js.map
